module.exports = __webpack_public_path__ + "static/media/special-handling.6bdfe350.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tutorial/images/special-handling.svg
 ** module id = 884
 ** module chunks = 0
 **/